<template>
  <a :href="link"
     :title="title"
     :class="['link', { link_dashed: dashed }]"
     target="_blank"
  >{{ sanitizeText | stringMaxLength(length) }}</a>
</template>

<script>
import { sanitizeHtml } from '@/utils/string'

export default {
  name: 'AppLink',
  props: {
    title: String,
    link: [String, Number],
    text: {
      type: String
    },
    dashed: Boolean,
    disabled: Boolean,
    length: [String, Number]
  },
  data () {
    return {}
  },
  computed: {
    sanitizeText () {
      return sanitizeHtml(this.text.toString())
    }
  },
  methods: {}
}
</script>
